import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { EyeIcon, MapIcon, ClockIcon, SparklesIcon, MoonIcon } from 'lucide-react';
export function Solution() {
  const features = [{
    icon: <EyeIcon className="w-8 h-8 text-sage" data-id="element-157" />,
    title: 'La Guía Digital Clean Slate Latina',
    description: 'El paso a paso del método de 15 minutos, diseñado específicamente para tu ritmo de vida.'
  }, {
    icon: <MapIcon className="w-8 h-8 text-sage" data-id="element-158" />,
    title: 'Mapa de Zonas de Pánico',
    description: "Identifica los 3 puntos críticos de tu hogar que definen la percepción de 'limpieza'."
  }, {
    icon: <ClockIcon className="w-8 h-8 text-sage" data-id="element-159" />,
    title: 'Protocolo Relámpago',
    description: 'Minuto a minuto: Exactamente qué hacer cuando te avisan que vienen en camino.'
  }, {
    icon: <SparklesIcon className="w-8 h-8 text-sage" data-id="element-160" />,
    title: 'Lista de 5 Esenciales',
    description: 'Los únicos productos de combate que realmente necesitas para mantener el orden sin gastar de más.'
  }, {
    icon: <MoonIcon className="w-8 h-8 text-sage" data-id="element-161" />,
    title: 'Ritual de Cierre de Cocina',
    description: '10 minutos nocturnos estratégicos para despertar con una casa que te abraza, no que te estresa.'
  }];
  return <section className="py-20 bg-light-sage relative overflow-hidden" data-id="element-162">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-163">
        <div className="absolute top-[-10%] left-[-5%] w-96 h-96 bg-white/40 rounded-full blur-3xl" data-id="element-164"></div>
        <div className="absolute bottom-[-10%] right-[-5%] w-96 h-96 bg-terra/10 rounded-full blur-3xl" data-id="element-165"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-166">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-167">
          <FadeIn data-id="element-168">
            <h2 className="text-3xl md:text-5xl font-bold text-olive mb-6" data-id="element-169">
              Presentamos el{' '}
              <span className="text-terra" data-id="element-170">Triaje Doméstico</span>
            </h2>
            <p className="text-xl text-olive/80 leading-relaxed" data-id="element-171">
              En lugar de limpiar para desinfectar, aprendes a{' '}
              <strong data-id="element-172">"limpiar para calmar el ojo"</strong>. Es un sistema de
              psicología visual que te permite transformar una habitación en 15
              minutos exactos, priorizando lo que los invitados notan primero y
              gestionando el resto de forma inteligente.
            </p>
          </FadeIn>
        </div>

        <div className="mb-12 text-center" data-id="element-173">
          <FadeIn delay={100} data-id="element-174">
            <h3 className="text-2xl font-serif font-bold text-olive mb-8" data-id="element-175">
              Lo que obtienes hoy:
            </h3>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-176">
          {features.map((feature, index) => <FadeIn key={index} delay={200 + index * 100} direction="up" data-id="element-177">
              <div className="bg-white rounded-2xl p-8 shadow-soft h-full border border-white hover:border-sage/30 transition-colors duration-300" data-id="element-178">
                <div className="bg-light-sage w-16 h-16 rounded-2xl flex items-center justify-center mb-6" data-id="element-179">
                  {feature.icon}
                </div>
                <h4 className="text-xl font-bold text-olive mb-3" data-id="element-180">
                  {feature.title}
                </h4>
                <p className="text-olive/70 leading-relaxed" data-id="element-181">
                  {feature.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}